export default __webpack_public_path__ + "static/4_28-64a07170c148d8d5167073e050d8f855.png";